import { LitElement, html, css } from "lit";
import { auth, db } from "../../firebase-config"; // Import your Firebase config
import { onAuthStateChanged, signOut } from "firebase/auth";
import { customElement, property, state } from "lit/decorators.js";
import {
  getDocs,
  collection,
  query,
  where,
  doc,
  deleteDoc,
  getDoc,
} from "firebase/firestore";
import "../../components/popup/reusable-popup";

@customElement("survey-dashboard-component")
export class SurveyDashboardComponent extends LitElement {
  @property({ type: Object }) user = null;

  static properties = {
    organizations: { type: Array },
    surveys: { type: Array },
    // selectedOrg: { type: String }, // Store selected organizations
    activeTab: { type: String },
    // selectedOption: { type: String },
  };
  @property({ type: Object }) isEditing = {
    name: false,
    image: false,
    memberIndex: null, // Track which member is being edited
  };
  @property({ type: String }) newOrganizationImage = "";
  @property({ type: String }) tempMemberName = ""; // Temp name for the editing member

  @property({ type: Object }) user = null;
  // @property({ type: Array }) organizations = [];
  @property({ type: Array }) surveys = [];
  // @property({ type: String }) selectedOrg = localStorage.getItem('selectedOrg') || '';
  // @property({ type: String }) selectedOption = localStorage.getItem('selectedOrg') || '';
  //@property({ type: Boolean }) isOrgLoaded = false;
  @state() organizations = [];
  @state() showPopup = false;
  @state() popupMessage = "";
  @state() organizationData = null; // Holds the incoming data
  @state() selectedOrg = null; // Stores the selected organization
  @state() isOrgLoaded = false; // Indicates if the organization data is loaded

  static styles = css`
    .container {
      padding: 2%;
      max-width: 1200px;
      margin: auto;
      width: 90%;
    }

    .content {
      display: flex;
      background-color: white;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      padding: 20px;
    }

    .sidebar button {
      width: 100%;
      padding: 15px;
      background-color: #f28b82;
      border: none;
      color: white;
      cursor: pointer;
      border-radius: 10px;
      font-weight: bold;
      margin-bottom: 20px;
    }

    .sidebar ul {
      list-style: none;
      padding: 0;
    }

    .sidebar ul li {
      margin: 20px 0;
      display: flex;
      align-items: center;
      cursor: pointer;
      padding: 10px;
      border-radius: 8px;
    }

    .sidebar ul li span {
      margin-left: 10px;
      font-size: 16px;
    }

    .active-tab {
      background-color: #d9d9d980;
      font-weight: bold;
      border-left: 5px solid #f28b82;
    }

    .survey-table {
      flex: 1;
      border-collapse: collapse;
    }

    .survey-table th,
    .survey-table td {
      padding: 1px;
      text-align: left;
      border-bottom: 1px solid #ddd;
    }

    .survey-table th,
    .survey-table td button {
      background: rgb(142, 73, 83);
      border: none;
      cursor: pointer;
    }

    .survey-table td button {
      background: rgb(142, 73, 83);
      border: none;
      cursor: pointer;
      color: white;

      padding: 10px 20px;
      font-size: 16px;
      border-radius: 10px;

      display: flex;
      align-items: center;
    }

    .survey-table th,
    .survey-table :nth-child(3) {
      text-align: center;
      padding-right: 20px;
    }

    .survey-table thead tr th {
      background-color: #f4f4f4;
      font-weight: bold;
      padding: 30px 0px 10px 10px;
    }

    .survey-table tbody tr td {
      padding: 15px 0px 10px 10px;
    }

    .icon-button {
      cursor: pointer;
      margin-left: 10px;
    }

    /* General container */

    /* Top Bar (Create Survey Button and Dropdown) */
    .top-bar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px;
      border-bottom: 1px solid #ccc;
    }

    .create-survey-btn {
      background-color: rgb(142, 73, 83);
      color: white;
      border: none;
      padding: 10px 20px;
      font-size: 16px;
      border-radius: 10px;
      cursor: pointer;
      display: flex;
      align-items: center;
    }

    .create-survey-btn i {
      margin-right: 10px;
    }

    .dropdown select {
      padding: 8px;
      font-size: 14px;
      border-radius: 5px;
      border: 1px solid #ccc;
    }

    /* Main content area (split into sidebar and content) */
    .main-content {
      display: flex;
      flex: 1;
      overflow: hidden;
    }

    /* Sidebar */
    .sidebar {
      width: 140;
      padding: 20px;

      border-right: 1px solid #ccc;
    }

    .tabs {
      list-style: none;
      padding: 0;
    }

    .tab {
      display: flex;
      align-items: center;
      padding: 15px 0;
      cursor: pointer;
    }

    .tab i {
      margin-right: 10px;
    }

    .active {
      font-weight: bold;
    }

    .count {
      background-color: #f28b82;
      color: white;
      border-radius: 12px;
      padding: 2px 6px;
      margin-left: 8px;
    }

    /* Right Content: Survey Data */
    .content {
      flex: 1;
      padding: 20px;
      background-color: white;
      overflow-y: auto;
    }

    .survey-table {
      width: 100%;
      border-collapse: collapse;
    }

    .survey-table th,
    .survey-table td {
      padding: 1px;
      text-align: left;
    }

    .survey-table tr:hover {
      background-color: #f0f0f0;
    }

    .survey-table input[type="checkbox"] {
      margin-right: 10px;
    }

    td button svg {
      vertical-align: middle;
    }

    .survey-table td button:hover {
      color: #fff;
    }

    button.edit-delete-btn {
      align-items: center;
      gap: 8px;
      border: none;
      background: none;
      cursor: pointer;
      background: none;
      border: none;
    }

    select {
      padding: 8px;
      font-size: 16px;
    }

    .table-container {
      width: 100%;
      margin: 20px auto;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
    }

    /* Table */
    table {
      width: 100%;
      border-collapse: collapse;
      font-family: Arial, sans-serif;
    }

    /* Table Header */
    thead {
      background-color: #d9d9d9;
      font-weight: bold;
      text-align: left;
    }

    thead th {
      padding: 25px;
    }

    /* Table Footer */
    tfoot {
      background-color: #d9d9d9;
      text-align: center;
      padding: 25px;
    }

    tfoot td {
      padding: 25px;
    }

    /* Table Rows */
    tbody tr {
      border-bottom: 1px solid #e0e0e0;
    }

    tbody tr:hover {
      background-color: #f9f9f9;
    }

    /* Table Data */
    td {
      padding: 12px;
      vertical-align: middle;
    }

    /* Checkbox styling */
    input[type="checkbox"] {
      width: 18px;
      height: 18px;
      cursor: pointer;
    }

    /* Edit and Delete Icons */
    .icon {
      cursor: pointer;
      margin: 0 8px;
      color: #333;
      font-size: 16px;
      vertical-align: middle;
      transition: color 0.3s ease;
    }

    .icon:hover {
      color: #007bff;
    }

    /* Survey Name Link */
    .survey-name {
      text-decoration: none;
      color: #333;
      font-weight: 500;
      cursor: pointer;
    }

    .survey-name span {
      margin-left:5px;
    }

    .survey-name:hover {
      text-decoration: none;
      color: #8e4953;
      cursor: pointer;
    }

    .button {
      background-color: #8e4953;
      border: 0 solid #e2e8f0;
      border-radius: 1.5rem;
      box-sizing: border-box;
      color: #ffffff;
      cursor: pointer;
      display: inline-block;
      font-family: "Basier circle", -apple-system, system-ui, "Segoe UI", Roboto,
        "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
        "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
      font-size: 1.1rem;
      font-weight: 600;
      line-height: 1;
      padding: 1rem 1.6rem;
      text-align: center;
      text-decoration: none #ffffff solid;
      text-decoration-thickness: auto;
      transition: all 0.1s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow: 0px 1px 2px rgba(166, 175, 195, 0.25);
      user-select: none;
      -webkit-user-select: none;
      touch-action: manipulation;
    }

    .button:hover {
      margin-top: 0px;
      -moz-box-shadow: 0px 0px 4px 1px grey;
      -webkit-box-shadow: 0px 0px 4px 1px grey;
      box-shadow: 0px 0px 4px 1px grey;
    }

    @media (min-width: 768px) {
      .button {
        font-size: 1.125rem;
        padding: 1rem 2rem;
      }
    }
  `;

  constructor() {
    super();
    this.user = null;
    this.organizations = [];
    this.surveys = [];
    this.activeTab = "active";
    //this.selectedOrg = localStorage.getItem('selectedOrg') || ''; // Load from localStorage
    // this.selectedOption = localStorage.getItem('selectedOrg') || ''; // Load from localStorage
    this.handleConfirm = this.handleConfirm.bind(this); // Bind event handler
  }

  // Helper function to fetch Firebase auth token
  async getAuthToken() {
    const auth = getAuth();
    const user = auth.currentUser;
    if (user) {
      return await user.getIdToken(); // Get the ID token
    }
    throw new Error("User not authenticated");
  }

  showSuccessPopup(message) {
    this.popupMessage = message;
    this.showPopup = true;
    setTimeout(() => {
      this.showPopup = false;
      this.requestUpdate(); // Trigger a re-render to hide the popup
    }, 3000); // Auto-hide after 3 seconds
    this.requestUpdate(); // Trigger a re-render immediately after showing the popup
  }

  connectedCallback() {
    super.connectedCallback();
    this.checkAuth();
    // Use arrow function or bind `this`
    document.addEventListener(
      "org-changed",
      this.handleDropOrgChange.bind(this)
    );
    // Add event listener to the 'confirm' event
    document.addEventListener("confirmBtn", this.handleConfirm);
    document.addEventListener("org-data", this.handleUpdateData.bind(this));
    //this.fetchSurveysByOrg(this.selectedOrg, 'active');
  }

  disconnectedCallback() {
    // Clean up event listener
    document.removeEventListener(
      "org-changed",
      this.handleDropOrgChange.bind(this)
    );
    document.removeEventListener("confirmBtn", this.handleConfirm);
    document.removeEventListener("org-data", this.handleUpdateData.bind(this));
    super.disconnectedCallback();
  }

  handleDropOrgChange(event) {
    console.log(
      "Event caught handleDropOrgChange:",
      event.detail.selectedOrgValue
    );
    const { selectedOrgValue } = event.detail;
    this.fetchSurveysByOrg(selectedOrgValue);
  }

  handleUpdateData(event) {
    let { dataOrg } = event.detail; // Extract data from the event
    console.log("Received data from header:", dataOrg);

    // Check if dataOrg is an array
    if (Array.isArray(dataOrg) && dataOrg.length > 0) {
      // If array has more than 1 element, set the first value
      this.organizationData = dataOrg[0]; // Set the first item in the array
      this.selectedOrg = dataOrg[0].id; // Set the selected organization id (assuming each has an 'id')
      console.log("First organization's ID: ", this.selectedOrg);
    } else if (dataOrg && dataOrg.id) {
      // If it's not an array but an object with an 'id', set it directly
      this.organizationData = dataOrg;
      this.selectedOrg = dataOrg.id;
      console.log("Single organization's ID: ", this.selectedOrg);
    } else {
      // Handle case where there is no valid data
      this.organizationData = null;
      this.selectedOrg = null;
      console.log("No valid organization data.");
    }

    // After updating the organization data, call the fetchSurveysByOrg method
    if (this.selectedOrg) {
      this.fetchSurveysByOrg(this.selectedOrg);
    }

    // Flag that the organization data is loaded
    this.isOrgLoaded = true;
  }

  // Lifecycle method to capture property changes
  updated(changedProperties) {
    if (changedProperties.has("activeTab")) {
      this.requestUpdate(); // Explicitly trigger a re-render when tab changes
    }
  }

  // Handle tab change
  handleTabChange(tab) {
    this.activeTab = tab;
    this.requestUpdate(); // Ensure component updates after tab change
  }

  checkAuth() {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        this.user = user;
        this.selectedTab = "active"; // Default tab
        this.requestUpdate();
      } else {
        this.user = null;
        this.requestUpdate();
      }
    });
  }

  async viewSurveyReport(surveryId) {
    const pageLoader = this.shadowRoot.querySelector("page-loader");
    pageLoader.loadShowPage(); // Call the loadPage method in the PageLoader component
    await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate delay
    pageLoader.loadHidePage();

    this.dispatchEvent(
      new CustomEvent("navigate-to-route", {
        detail: { routePath: "/reports/view/" + surveryId },
        bubbles: true,
        composed: true,
      })
    );

    console.log("Create Report:");
  }
  handleCreateSurvey() {
    //alert('Create Survey button clicked!');
    this.dispatchEvent(
      new CustomEvent("navigate-to-route", {
        detail: { routePath: "/survey/create" },
        bubbles: true,
        composed: true,
      })
    );
  }

  handleEdit(survey) {
    console.log("Edit survey:", survey.title);
    alert(`Editing ${survey.name}`);
    // Add logic for editing here
  }

  handleDelete(survey) {
    console.log("Delete survey:", survey.title);
    this.surveys = this.surveys.filter((s) => s.id !== survey.id);
  }

  capitalizeFirstLetter(str) {
    if (!str) return ""; // Handle empty string
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  // Event handler function
  handleConfirm(event) {
    //const message = event.detail.message;  // Access any data passed with the event
    const id = event.detail.id;
    const action = event.detail.action;

    if (action == "edit") {
      console.log("Confirm event triggered:", id + action);
      this.dispatchEvent(
        new CustomEvent("navigate-to-route", {
          detail: { routePath: "/edit-survey?id=" + id },
          bubbles: true,
          composed: true,
        })
      );
    } else if (action == "delete") {
      console.log("Confirm event triggered:", id + action);
      this.surveyId = id;
      this.deleteSurvey();
    } else {
      console.log("Confirm event triggered:", id + action);
    }
    // Add any logic you want to execute when 'confirm' is triggered
  }

  async getSurveyStatus(surveyId) {
    // Reference to the survey document in the 'surveys' collection by its ID
    const surveyRef = doc(db, "surveys", surveyId);

    try {
      // Fetch the survey document data
      const surveySnap = await getDoc(surveyRef);

      if (surveySnap.exists()) {
        const surveyData = surveySnap.data();
        console.log("Survey data:", surveyData);
        // If you are specifically looking for the status field
        const status = surveyData.status; // Assuming 'status' is a field in the document
        return status; // You can return or process the status as needed
      } else {
        console.log("No such survey!");
        return null; // If the document does not exist
      }
    } catch (error) {
      console.error("Error getting survey status:", error);
    }
  }

  async fetchSurveysByOrg(orgId) {
    try {
      const pageLoader = this.shadowRoot.querySelector("page-loader");
      pageLoader.loadShowPage(); // Call the loadPage method in the PageLoader component

      const surveysRef = collection(db, "surveys"); // Reference to the 'cities' collection
      const orgRef = doc(db, "organizations", orgId);
      const queryRef = query(
        surveysRef,
        where("organization_id", "==", orgRef) // Filtering by organization_id (reference field)
        //where('is_deleted', '==', 'no') // Filtering by status
      );
      const querySnapshot = await getDocs(queryRef); // Get documents based on the query
      // Get documents based on the query
      const surveysList = [];
      // Check if documents exist
      if (querySnapshot.empty) {
        this.isOrgLoaded = false; // No organization found
        console.log(
          "No surveys found for the specified organization and status."
        );
        pageLoader.loadHidePage();
        //return; // Exit if no documents found
      }
      // Extract survey data from the query snapshot
      querySnapshot.forEach((doc) => {
        surveysList.push({ id: doc.id, ...doc.data() });
      });
      console.log("Fetched Surveys:", surveysList); // Log the fetched surveys
      this.surveys = surveysList; // Store the fetched survey data in the component's property
      this.isOrgLoaded = true;
      this.requestUpdate(); // Organization found
      // Additional log to confirm that organization data was found and processed
      console.log("Organization data loaded and component updated.");
      pageLoader.loadHidePage();
    } catch (error) {
      console.error("Error fetching surveys: ", error);
      this.isOrgLoaded = false;
      this.requestUpdate();
      pageLoader.loadHidePage();
    }
  }

  async deleteSurvey() {
    if (!this.surveyId) {
      console.error("Survey ID is missing. Cannot delete survey.");
      return;
    }

    try {
      const surveyRef = doc(db, "surveys", this.surveyId);

      //const surveyStatus = this.getSurveyStatus(this.surveyId);
      const surveyStatus = await this.getSurveyStatus(this.surveyId);

      // Now you can use the surveyStatus
      console.log("Survey Status:", surveyStatus);
      console.log("surveyStatus" + surveyStatus);

      if (surveyStatus != "draft") {
        //console.error("Cannot delete "+ surveyStatus + "survey.");
        this.showSuccessPopup("Cannot delete survey");
        return;
      }

      await deleteDoc(surveyRef);
      console.log(`Survey with ID ${this.surveyId} deleted successfully.`);
      this.successMessage = `Survey deleted successfully.`;
      // this.showSuccessPopup('Survey deleted successfully.');

      // Optionally, dispatch an event or redirect to another page
      this.dispatchEvent(
        new CustomEvent("navigate-to-route", {
          detail: { routePath: "/" }, // Redirect to the surveys list page
          bubbles: true,
          composed: true,
        })
      );
    } catch (error) {
      console.error("Error deleting survey: ", error);
      this.errors.general =
        "An error occurred while deleting the survey. Please try again.";
    }
  }

  viewSurvey(surveyid) {
    this.dispatchEvent(
      new CustomEvent("navigate-to-route", {
        detail: { routePath: "/survey/view/" + surveyid }, // Redirect to the surveys list page
        bubbles: true,
        composed: true,
      })
    );
  }

  viewPublishSurvey(surveyid) {
    this.dispatchEvent(
      new CustomEvent("navigate-to-route", {
        detail: { routePath: "/survey/publish/" + surveyid }, // Redirect to the surveys list page
        bubbles: true,
        composed: true,
      })
    );
  }

  editSurvey(surveyid) {
    this.dispatchEvent(
      new CustomEvent("navigate-to-route", {
        detail: { routePath: "/survey/edit/" + surveyid }, // Redirect to the surveys list page
        bubbles: true,
        composed: true,
      })
    );
  }

  openDeletePopup(surveyid) {
    const popup = this.shadowRoot.querySelector("#delete-popup");
    //popup.message = `Are you sure you want to delete the survey with ID: ${surveyid}?`; // Use the survey ID in the message
    popup.message = `Are you sure you want to delete the survey ?`; // Use the survey ID in the message

    popup.confirmText = "Delete";
    popup.cancelText = "Cancel";
    popup.id = surveyid; // Attach surveyid for further use (e.g., delete operation)
    popup.action = "delete"; // Attach surveyid for further use (e.g., delete operation)
    popup.open();
  }

  openEditPopup(surveyid, status = null) {
    const popup = this.shadowRoot.querySelector("#edit-popup");

    //popup.message = `Are you sure you want to edit the survey with ID: ${surveyid}?`;
    popup.message =
      `Are you sure you want to ` + (status == "edit" ? "edit" : "closed");
    +` the survey ?`;
    popup.confirmText = status == "edit" ? "Edit" : "Closed";
    popup.id = surveyid; // Attach surveyid for further use (e.g., edit operation)
    popup.action = status == "edit" ? "edit" : "closed"; // Attach surveyid for further use (e.g., edit operation)
    popup.open();
  }

  render() {
    // Filter surveys based on the active tab
    const filteredSurveys = this.surveys.filter(
      (survey) => survey.status === this.activeTab
    );

    console.log("this.selectedOrg" + this.isOrgLoaded);
    console.log("this.isOrgLoaded" + this.selectedOrg);
    return html`
      <page-loader></page-loader>
      <header-component></header-component>
      <main>
        <div class="main">
          <!-- <h2 style="text-align:center">Welcome to Data Point Studio</h2> -->
          <div class="container">
            ${this.user && (this.selectedOrg || this.selectedOrg != "")
              ? html`<div class="top-bar">
                    <button class="button" @click="${
                      this.handleCreateSurvey
                    }" class="create-survey-btn">
                         <i class="fas fa-pencil-alt"></i> Create Survey</button>
                         <!-- <button class="button" @click="${
                           this.handleCreateReport
                         }" class="create-survey-btn">
                         <i class="fas fa-pencil-alt"></i> Create Report</button> -->
                </div>
                <div class="main-content">
                     <!-- Left Sidebar: Menus -->
                     <div class="sidebar">
                        <ul class="tabs">
                            <li class="${
                              this.activeTab === "active" ? "active-tab" : ""
                            }" @click="${() => this.handleTabChange("active")}">
                                 <svg width="28" height="30" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title/><path d="M16,12a1,1,0,0,1-.49.86l-5,3A1,1,0,0,1,10,16a1,1,0,0,1-.49-.13A1,1,0,0,1,9,15V9a1,1,0,0,1,1.51-.86l5,3A1,1,0,0,1,16,12Z" fill="#464646"/><path d="M21.92,5.09a1,1,0,0,0-1.07.15L19.94,6A9.84,9.84,0,0,0,12,2a10,10,0,1,0,9.42,13.33,1,1,0,0,0-1.89-.66A8,8,0,1,1,12,4a7.87,7.87,0,0,1,6.42,3.32l-1.07.92A1,1,0,0,0,18,10h3.5a1,1,0,0,0,1-1V6A1,1,0,0,0,21.92,5.09Z" fill="#464646"/></svg><span>Active</span>
                                    <span>(${
                                      this.surveys.filter(
                                        (survey) => survey.status === "active"
                                      ).length
                                    })</span>
                            </li>
            
                            <li class="${
                              this.activeTab === "draft" ? "active-tab" : ""
                            }" @click="${() => this.handleTabChange("draft")}">
                                  <svg width="28" height="30" viewBox="0 0 28 30" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_1346_1596)"><path d="M23.99 9.5C23.99 8.78 23.62 8.15 23.05 7.8L14 2.5L4.95 7.8C4.38 8.15 4 8.78 4 9.5V19.5C4 20.6 4.9 21.5 6 21.5H22C23.1 21.5 24 20.6 24 19.5L23.99 9.5ZM21.99 9.5V9.51L14 14.5L6 9.5L14 4.82L21.99 9.5ZM6 19.5V11.84L14 16.86L21.99 11.87L22 19.5H6Z" fill="black"/></g><defs><filter id="filter0_d_1346_1596" x="-2" y="0" width="32" height="32" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1346_1596"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1346_1596" result="shape"/></filter></defs></svg>
                                    <span>Draft</span><span>(${
                                      this.surveys.filter(
                                        (survey) => survey.status === "draft"
                                      ).length
                                    })</span>
                            </li>
                            <li class="${
                              this.activeTab === "closed" ? "active-tab" : ""
                            }" @click="${() => this.handleTabChange("closed")}">
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 16V2C16 0.9 15.1 0 14 0H4C2.9 0 2 0.9 2 2V16H0V18H18V16H16ZM14 16H4V2H14V16Z" fill="black"/><path d="M8 8H6V10H8V8Z" fill="black"/></svg>
                                    <span>Closed</span><span>(${
                                      this.surveys.filter(
                                        (survey) => survey.status === "closed"
                                      ).length
                                    })</span>
                            </li>
                            <li class="${
                              this.activeTab === "archived" ? "active-tab" : ""
                            }" @click="${() =>
                  this.handleTabChange("archived")}">
                                     <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 16.125V0.125H2V16.125H0V18.125H11.25C11.25 19.095 12.03 19.875 13 19.875C13.97 19.875 14.75 19.095 14.75 18.125H20V16.125H18ZM16 8.125H14V6.125H16V8.125ZM12 8.125H4V6.125H12V8.125ZM12 10.125V12.125H4V10.125H12ZM14 10.125H16V12.125H14V10.125ZM16 4.125H14V2.125H16V4.125ZM12 2.125V4.125H4V2.125H12ZM4 16.125V14.125H12V16.125H4ZM14 16.125V14.125H16V16.125H14Z" fill="black"/></svg>
                                     <span>Archived</span><span>(${
                                       this.surveys.filter(
                                         (survey) =>
                                           survey.status === "archived"
                                       ).length
                                     })</span>
                             </li>
                        </ul>
                     </div>
                
                     <!-- Right Content: Survey Data List -->
                        <div class="content">
                        <div class="table-container">
    <table>
      <!-- Table Header -->
      <thead>
        <tr>
         
         <th colspan="4"></th>
        </tr>
      </thead>

      <!-- Table Body -->
      <tbody>
        ${
          filteredSurveys.length > 0
            ? html`${filteredSurveys.map(
                (survey, index) => html`
                  <tr>
                    <td id="view-${index}-${survey.id}">
                      <a
                        @click="${() => this.viewSurvey(survey.id, "view")}"
                        class="survey-name"
                        >${survey.title}</a
                      >
                    </td>
                    ${survey.status === "active"
                      ? html`
                          <td id="publish-${index}-${survey.id}">
                            <a
                              @click="${() =>
                                this.viewPublishSurvey(survey.id, "view")}"
                              class="survey-name"
                              ><svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="19"
                                viewBox="0 0 24 20"
                              >
                                <path
                                  d="M15 12c0 1.654-1.346 3-3 3s-3-1.346-3-3 1.346-3 3-3 3 1.346 3 3zm9-.449s-4.252 8.449-11.985 8.449c-7.18 0-12.015-8.449-12.015-8.449s4.446-7.551 12.015-7.551c7.694 0 11.985 7.551 11.985 7.551zm-7 .449c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5 5-2.243 5-5z"
                                />
                              </svg>
                               <span>View Survey</span></a
                            >
                          </td>
                          <td id="report-${index}-${survey.id}">
                            <a
                              @click="${() =>
                                this.viewSurveyReport(survey.id, "view")}"
                              class="survey-name"
                            >
                              <?xml version="1.0" encoding="UTF-8"?>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                width="24px"
                                height="px"
                                viewBox="0 0 24 31"
                                version="1.1"
                              >
                                <g id="surface1">
                                  <path
                                    style=" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;"
                                    d="M 3.9375 0 L 16.214844 0 C 16.425781 0 16.613281 0.0898438 16.742188 0.230469 L 23.773438 6.847656 C 23.917969 6.980469 23.988281 7.164062 23.988281 7.34375 L 23.992188 27.160156 C 23.992188 29.261719 22.214844 31 20.0625 31 L 3.9375 31 C 1.78125 31 0.0078125 29.265625 0.0078125 27.160156 L 0.0078125 3.84375 C 0.0078125 1.730469 1.78125 0 3.9375 0 Z M 17.085938 2.464844 L 17.085938 4.308594 C 17.234375 6.226562 18.5625 6.949219 20.402344 6.980469 L 21.878906 6.980469 Z M 22.578125 8.285156 C 22.480469 8.332031 22.371094 8.359375 22.253906 8.359375 L 20.390625 8.359375 C 17.800781 8.316406 15.886719 7.0625 15.679688 4.40625 L 15.671875 4.308594 L 15.671875 1.382812 L 3.9375 1.382812 C 2.550781 1.382812 1.421875 2.488281 1.421875 3.84375 L 1.421875 15.152344 L 22.578125 15.144531 Z M 1.421875 16.519531 L 1.421875 27.160156 C 1.421875 28.511719 2.554688 29.617188 3.9375 29.617188 L 20.0625 29.617188 C 21.4375 29.617188 22.578125 28.5 22.578125 27.160156 L 22.578125 16.527344 Z M 3.964844 8.664062 L 5.839844 8.664062 C 5.910156 8.664062 5.957031 8.710938 5.957031 8.78125 L 5.957031 14.089844 C 5.957031 14.15625 5.910156 14.203125 5.839844 14.203125 L 3.964844 14.203125 C 3.894531 14.203125 3.847656 14.15625 3.847656 14.089844 L 3.847656 8.78125 C 3.824219 8.710938 3.894531 8.664062 3.964844 8.664062 Z M 7.515625 6.484375 L 9.390625 6.484375 C 9.460938 6.484375 9.507812 6.53125 9.507812 6.597656 L 9.507812 14.089844 C 9.507812 14.15625 9.460938 14.203125 9.390625 14.203125 L 7.515625 14.203125 C 7.445312 14.203125 7.398438 14.15625 7.398438 14.089844 L 7.398438 6.597656 C 7.398438 6.53125 7.445312 6.484375 7.515625 6.484375 Z M 18.164062 11.28125 L 20.042969 11.28125 C 20.113281 11.28125 20.160156 11.328125 20.160156 11.394531 L 20.160156 14.066406 C 20.160156 14.136719 20.113281 14.179688 20.042969 14.179688 L 18.164062 14.179688 C 18.097656 14.179688 18.050781 14.136719 18.050781 14.066406 L 18.050781 11.394531 C 18.050781 11.351562 18.097656 11.28125 18.164062 11.28125 Z M 11.066406 9.984375 L 12.941406 9.984375 C 13.011719 9.984375 13.058594 10.03125 13.058594 10.097656 L 13.058594 14.066406 C 13.058594 14.136719 13.011719 14.179688 12.941406 14.179688 L 11.066406 14.179688 C 10.996094 14.179688 10.949219 14.136719 10.949219 14.066406 L 10.949219 10.097656 C 10.949219 10.054688 10.996094 9.984375 11.066406 9.984375 Z M 14.613281 9.058594 L 16.492188 9.058594 C 16.5625 9.058594 16.609375 9.109375 16.609375 9.175781 L 16.609375 14.089844 C 16.609375 14.15625 16.5625 14.203125 16.492188 14.203125 L 14.613281 14.203125 C 14.542969 14.203125 14.496094 14.15625 14.496094 14.089844 L 14.496094 9.175781 C 14.496094 9.109375 14.542969 9.058594 14.613281 9.058594 Z M 12.53125 23.832031 L 16.269531 23.898438 C 16.269531 25.210938 15.609375 26.414062 14.511719 27.144531 Z M 12.28125 18.175781 C 13.160156 18.242188 13.753906 18.347656 14.546875 18.734375 C 16.066406 19.507812 17.121094 21.058594 17.207031 22.820312 L 17.230469 23.101562 L 16.945312 23.101562 L 12.613281 22.972656 L 12.371094 22.972656 Z M 12.855469 22.457031 L 16.660156 22.5625 C 16.433594 20.417969 14.902344 19.121094 12.808594 18.710938 Z M 11.277344 23.453125 L 13.410156 27.066406 C 12.75 27.429688 12.027344 27.625 11.277344 27.625 C 8.925781 27.625 7.011719 25.753906 7.011719 23.453125 C 7.011719 21.214844 8.816406 19.363281 11.101562 19.277344 Z M 11.277344 23.453125 "
                                  />
                                </g>
                              </svg>

                             <span>View Report</span> </a
                            >
                          </td>
                        `
                      : ``}

                    <td id="edit-${index}-${survey.status}">
                      <a
                        @click="${() => this.editSurvey(survey.id, "edit")}"
                        class="survey-name"
                        ><svg
                          width="18"
                          height="16"
                          viewBox="0 0 18 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M12 12L8 16H18V12H12Z" fill="black" />
                          <path
                            d="M9.06 3.19L0 12.25V16H3.75L12.81 6.94L9.06 3.19ZM2.92 14H2V13.08L9.06 6.02L9.98 6.94L2.92 14Z"
                            fill="black"
                          />
                          <path
                            d="M15.71 4.04C16.1 3.65 16.1 3.02 15.71 2.63L13.37 0.29C13.17 0.09 12.92 0 12.66 0C12.41 0 12.15 0.1 11.96 0.29L10.13 2.12L13.88 5.87L15.71 4.04Z"
                            fill="black"
                          />
                        </svg>
                       <span> Edit</span></a
                      >
                    </td>
                    ${survey.status === "draft"
                      ? html`<td id="delete-${index}-${survey.status}">
                          <a
                            class="survey-name"
                            @click="${() =>
                              this.openDeletePopup(survey.id, "delete")}"
                          >
                            <svg
                              width="21"
                              height="24"
                              viewBox="0 0 23 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM8 9H16V19H8V9ZM15.5 4L14.5 3H9.5L8.5 4H5V6H19V4H15.5Z"
                                fill="black"
                              />
                            </svg>

                           <span>Delete</span> </a
                          >
                        </td>`
                      : ""}
                  </tr>
                `
              )}`
            : html` <tr>
                <td colspan="3">
                  No ${this.activeTab} surveys are available for this
                  organization at the moment. <br />
                  Please check back later or contact your administrator for more
                  information
                </td>
              </tr>`
        }
      </tbody>
      <!-- Table Footer -->
      <tfoot>
        <tr>
          <td colspan="4"></td>
        </tr>
      </tfoot>
    </table>
  </div>
                           
                            </div>
                        </div>
                    </div>
                    
               
          `
              : html` ${!this.selectedOrg || this.selectedOrg == ""
                  ? html`
                      <message-box
                        title="No Organization Assigned"
                        message="Please contact the admin for assistance."
                      ></message-box>
                    `
                  : html` <p>
                      You are not logged in. Please
                      <a href="/login">login</a> to manage your organization.
                    </p>`}`}
          </div>
        </div>
      </main>

      <reusable-popup
        id="delete-popup"
        @confirm=${this.handleDelete}
        @cancel=${() => console.log("Delete canceled")}
      ></reusable-popup>

      <reusable-popup
        id="edit-popup"
        @confirm=${this.handleEdit}
        @cancel=${() => console.log("Edit canceled")}
      ></reusable-popup>

      <footer-component></footer-component>
    `;
  }
}
